import { defineMessages } from 'gatsby-plugin-react-intl';

const messages = defineMessages({
  'prospectus.course.business.title': {
    id: 'prospectus.course.business.title',
    description: 'Title soliciting business interest in this course',
    defaultMessage: 'Interested in this course for your business or team?',
  },
  'prospectus.course.business_message': {
    id: 'prospectus.course.business_message',
    description: 'Message soliciting business interest in this course',
    defaultMessage: 'Train your employees in the most in-demand topics, with edX For Business.',
  },
  'prospectus.course.business.message': {
    id: 'prospectus.course.business.message',
    description: 'Message soliciting business interest in this course',
    defaultMessage: 'Train your employees in the most in-demand topics, with edX For Business.',
  },
});

export default messages;
